/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    systemRoleIdSelected:0,
    defaultDataSystemRole:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_SYSTEM_ROLE_ID = 'SET_SYSTEM_ROLE_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setSystemRoleId = (payload) => ({
  type: SET_SYSTEM_ROLE_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_SYSTEM_ROLE_ID:
        return {
          ...state,
        systemRoleIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataSystemRole: payload,
          }
     default:
       return state
   }
 }
 